import {ALookupRowsContainer} from "./lookup.rows.container";
import {Sps} from "./sps";

export class RequestedProcedure  extends ALookupRowsContainer{
	static sps_TYPE;

	requestedProcedureId:number;
	patientPersonKey: number;
	orderKey: number;
	rpCodeKey: number;

	paymentAmountCb?: number;
	paymentEligibleCb?: string; // 'Y' / 'N'
	paymentPrepaidCb?: string; // 'Y' / 'N'
	paymentReceiptNumCb?: string;
	paymentCreditNumCb?: string;

	sps: Sps[];

	studySeriesKey: number;

	get firstSps():Sps {
		let prop = 'sps';
		if (!this[prop] || !this[prop][0]) {
			this[prop] = [{}];
		}
		return this[prop][0];
	}
}
RequestedProcedure.sps_TYPE = Sps;
